module.exports = __webpack_public_path__ + "img/arrow.ff705d4c.png";